import React from 'react';
import {Button, Modal} from "react-bootstrap";
import {DataAPI, MutationAPI, useData, useMutator} from "../../services/API";
import {useParams} from "react-router-dom";
import {ModalUrl, useHandleClose} from "../../commons/ModalHelpers";
import {useQueryClient} from "react-query";
import Reports from "../Reports";
import Notifications from "../Notifications";

const DeleteDistribution = () => {
    const { id } = useParams();
    const queryClient = useQueryClient();

    const { isLoading, error, data: distribution } = useData(id, 'distribution', DataAPI.getDistribution);
    const handleClose = useHandleClose(Reports.url);
    const handleDeleteClose = useHandleClose(Reports.url, true);
    const deleteDistribution = useMutator(MutationAPI.deleteDistribution, {
        afterSuccess: () => {
            queryClient.invalidateQueries('reportdistribution');
            queryClient.removeQueries(['distribution', id], { exact: true });
            handleDeleteClose();
        },
        customMsg: 'Dystrybucja została usunięta'
    });

    const handleDelete = () => deleteDistribution.mutate(id);

    if (isLoading) return null;
    if (error) {
        Notifications.pushNew(error.message, 'danger');
        return null;
    }

    return (
        <Modal size="sm" show={true} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Usuń dystrybucję</Modal.Title>
            </Modal.Header>
            <Modal.Body className="confirm-body">
                <p>Czy na pewno chcesz usunąć dystrybucję raportu <strong>{distribution.name}</strong>?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>Anuluj</Button>
                <Button variant="danger" onClick={handleDelete}>Usuń</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteDistribution;

DeleteDistribution.url = `/distribution${ModalUrl}delete/:id`
DeleteDistribution.buildUrl = id => DeleteDistribution.url.replace(':id', id)


